import React from 'react';
import { Loader2 } from 'lucide-react';

export const Spinner = ({ size = 'md', className = '', label }) => {
  const sizeStyles = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-10 h-10',
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-3 p-4 ${className}`}>
      <Loader2 className={`animate-spin text-brand-600 dark:text-brand-400 ${sizeStyles[size]}`} />
      {label && (
        <p className="text-xs font-medium text-slate-500 dark:text-slate-400">{label}</p>
      )}
    </div>
  );
};

export const FullPageLoader = ({ message = 'Cargando Quinvoice...' }) => {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-slate-50 dark:bg-slate-950">
      <div className="w-14 h-14 rounded-2xl bg-brand-600 flex items-center justify-center text-white shadow-xl shadow-brand-600/30 mb-4 animate-pulse">
        <span className="font-bold text-2xl font-sans">Q</span>
      </div>
      <div className="flex items-center gap-2 text-slate-600 dark:text-slate-300 text-sm font-medium">
        <Loader2 className="w-4 h-4 animate-spin text-brand-600 dark:text-brand-400" />
        {message}
      </div>
    </div>
  );
};
